import { EventInfoCard } from "./EventInfoCard";

export default {
  title: "SecurityPortal/Events/EventInfoCard",
  component: EventInfoCard,
  parameters: {
    backgrounds: {
      default: "light",
    },
  },
  decorators: [
    (Story) => (
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          width: "1103px",
          fontFamily: "Helvetica Neue",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <EventInfoCard {...args} />;

export const Default = Template.bind({});
Default.args = {
  event: {
    name: "Spring Leadership 2022",
    center: "Las Vegas Event Center",
    city: "Las Vegas",
    state: "Nevada",
    date: "01-01-2022",
  },
  onClick: undefined,
};

export const WithDetails = Template.bind({});
WithDetails.args = {
  event: { ...Default.args.event, complaints: 22 },
  onClick: () => alert("Details clicked."),
};
